import { render } from "./Languages.vue?vue&type=template&id=167006b8&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-167006b8"

export default script